import { captureException } from '@sentry/react'
import { useState } from 'react'
import { MdChatBubbleOutline } from 'react-icons/md'
import { toast } from 'react-toastify'

import type { ReactElement } from 'react'

import CreateModal from './CreateModal'

import Button from '~/components/Buttons/Button'
import Modal from '~/components/Modal'
import { displayToast } from '~/utils/toast'

import './styles.scss'

const FeedbackButton = (): ReactElement => {
  /** Local state */

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)

  /** Handlers */

  const handleSuccess = (feedbackUrl: string) => {
    setIsCreateModalOpen(false)
    toast.success(
      <>
        {'Feedback successfully created. View it '}
        <span style={{ textDecoration: 'underline' }}> here</span>
      </>,
      {
        autoClose: false,
        onClick: () => window.open(feedbackUrl, '_blank'),
      }
    )
  }

  const handleFailure = (e: unknown) => {
    captureException(e)
    setIsCreateModalOpen(false)
    displayToast('Feedback could not be created', 'error')
  }

  const handleOpen = (value: boolean) => () => setIsCreateModalOpen(value)

  /** Render */

  return (
    <div className="feedback-button-component">
      <Button onClick={handleOpen(true)} size="small">
        <MdChatBubbleOutline size={13} />
        Feedback
      </Button>
      <Modal isOpen={isCreateModalOpen} onCloseModal={handleOpen(false)}>
        <CreateModal onClose={handleOpen(false)} onFailure={handleFailure} onSuccess={handleSuccess} />
      </Modal>
    </div>
  )
}

export default FeedbackButton
